function captchaExecute(action) {
    grecaptcha.execute('reCAPTCHA_site_key', {action: 'homepage'}).then(function(token) {
        return token;
    });
}
